import 'react-loading-skeleton/dist/skeleton.css';
import { createRoot } from 'react-dom/client';

import ReactModal from 'react-modal';
import * as Sentry from '@sentry/browser';
import App from './app/app';

Sentry.init({
  dsn: 'https://3478a7aed670499d988810214a2add02@o251606.ingest.sentry.io/6260532',
  environment: window.location.hostname,
  release: import.meta.env.VITE_VERSION,
  dist: import.meta.env.VITE_GIT_HASH,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  sendClientReports: true,
  ignoreErrors: ['Polling timed out', 'Sentry::ignore'],
  allowUrls: [
    /https?:\/\/((cdn|www)\.)?cspr\.live/,
    /https?:\/\/((cdn|www)\.)?testnet\.cspr\.live/,
    /https?:\/\/((cdn|www)\.)?integration\.cspr\.live/,
    /https?:\/\/((cdn|www)\.)?devnet\.cspr\.live/,
    /https?:\/\/((cdn|www)\.)?cspr-live\.dev\.make\.services/,
  ],
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['cspr-live-block-explorer-key'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      beforeErrorSampling: (event) => {
        const isUnhandled = event.exception?.values?.some(
          (exception) => exception.mechanism?.handled === false
        );

        return !!isUnhandled;
      },
    }),
  ],
  tracesSampleRate: 0.05,
  // Check if it is an exception, and if so, show the report dialog
  beforeSend(event, hint) {
    const ignoreReportDialog =
      hint.captureContext?.tags?.method.match('[casper-js-sdk]');

    if (event.exception && event.event_id && ignoreReportDialog === false) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  },
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click') {
      const target: HTMLElement | null | undefined = hint?.event?.target;
      let targetText = target?.textContent;
      if (targetText) {
        if (targetText.length > 100) {
          targetText = targetText.substring(0, 100) + '...';
        }
        breadcrumb.message = `${breadcrumb.message} (Text: ${targetText})`;
        // console.log(breadcrumb.message);
      }
    }

    return breadcrumb;
  },
});

window.addEventListener('vite:preloadError', (event) => {
  window.location.reload();
});

ReactModal.setAppElement('#root');

const container = document.getElementById('root');
const root = createRoot(container!, {
  onRecoverableError: (error, errorInfo) => {
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  },
});
root.render(
  // TODO: Since we have some issues with double-invoking useEffect in event-store-hooks,
  //  StrictMode is commented.
  //  We need to adapt our hooks to work with StrictMode.
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
);

// invalidate count: 6
